import { Card, Container, Table, TableBody, TableContainer } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import FormProvider from 'src/components/hook-form/form-provider';
import Scrollbar from 'src/components/scrollbar';
import { TableHeadCustom, TablePaginationCustom, TableSkeleton } from 'src/components/table';
import AppTableToolbar from 'src/components/table/AppTableToolbar';
import { USER_RECORDS_TABLE_HEAD } from 'src/constants/tables-heads';
import AddNewCategoryDialog from 'src/sections/dialogs/add/AddNewCategoryDialog';
import useUserRecords from './use-users-records';
import UsersRecordsRow from './users-records-row';

const UsersRecords = () => {
  const { addDialog, data, isLoading, methods, query, setQuery, t, table, handleSearch } =
    useUserRecords();

  return (
    <Container>
      <Helmet>
        <title>{t('sidebar.voiceRequests')}</title>
      </Helmet>
      <Card>
        <FormProvider methods={methods}>
          <AppTableToolbar
            handleSearch={handleSearch}
            tableName=""
            reset={methods.reset}
            search={query.search!}
          />
          <TableContainer>
            <Scrollbar>
              <Table>
                <TableHeadCustom
                  setQuery={setQuery}
                  headLabel={USER_RECORDS_TABLE_HEAD(t)}
                  methods={methods}
                />
                <TableBody>
                  {isLoading ? (
                    [...Array(table.rowsPerPage)].map((i, index) => (
                      <TableSkeleton key={index} sx={{ height: 80 }} />
                    ))
                  ) : (
                    <>
                      {data?.user_records?.map((row) => (
                        <UsersRecordsRow key={row.recordingId} row={row} />
                      ))}
                    </>
                  )}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          {data && (
            <TablePaginationCustom
              count={+data.user_records_aggregate.aggregate?.count!}
              page={+table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          )}
        </FormProvider>
        <AddNewCategoryDialog open={addDialog.value} onClose={addDialog.onFalse} />
      </Card>
    </Container>
  );
};

export default UsersRecords;
